import { useState } from "react";
import {
  Button,
  Collapse,
  Group,
  Stack,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { IconChevronRight, IconTrash } from "@tabler/icons-react";

interface DeleteSectionProps {
  onDelete: () => void;
  buttonLabel: string;
  description?: string;
  loading?: boolean;
  disabled?: boolean;
}

export function DeleteSection({
  onDelete,
  buttonLabel,
  description,
  loading,
  disabled,
}: DeleteSectionProps) {
  const [opened, setOpened] = useState(false);

  return (
    <Stack gap="xs">
      <UnstyledButton onClick={() => setOpened((o) => !o)}>
        <Group gap={4}>
          <IconChevronRight
            size={16}
            color="var(--mantine-color-red-6)"
            style={{
              transform: opened ? "rotate(90deg)" : undefined,
              transition: "transform 150ms ease",
            }}
          />
          <Text fw={600} size="sm" c="red">
            Delete
          </Text>
        </Group>
      </UnstyledButton>

      <Collapse in={opened}>
        <Stack gap="xs" pl={20}>
          {description && (
            <Text size="xs" c="dimmed">
              {description}
            </Text>
          )}
          <div>
            <Button
              variant="outline"
              color="red"
              size="xs"
              leftSection={<IconTrash size={14} />}
              onClick={onDelete}
              loading={loading}
              disabled={disabled}
            >
              {buttonLabel}
            </Button>
          </div>
        </Stack>
      </Collapse>
    </Stack>
  );
}
